import { Link, useLocation, useNavigate } from "react-router-dom";
import { Bitcoin, Flame, ShoppingBag, User, LogOut, Newspaper, HeartHandshake, MessageSquare, Play, Users, Zap } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/feed", label: "Feed", icon: Newspaper, id: "nav-feed" },
  { to: "/reels", label: "Reels", icon: Play, id: "nav-reels" },
  { to: "/bitdate", label: "BitDate", icon: Flame, id: "nav-bitdate" },
  { to: "/messages", label: "Msgs", icon: MessageSquare, id: "nav-messages" },
  { to: "/groups", label: "Groups", icon: Users, id: "nav-groups" },
  { to: "/marketplace", label: "Market", icon: ShoppingBag, id: "nav-marketplace" },
  { to: "/orders", label: "Orders", icon: Zap, id: "nav-orders" },
  { to: "/donate", label: "Donate", icon: HeartHandshake, id: "nav-donate" },
];

export default function TopNav() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  const onLogout = () => {
    logout();
    nav("/");
  };

  return (
    <header
      data-testid="top-nav"
      className="sticky top-0 z-50 bg-[#FDFBF7] border-b-2 border-black"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between gap-6">
        <Link
          to={user ? "/feed" : "/"}
          data-testid="brand-logo"
          className="flex items-center gap-2 font-display font-black text-2xl md:text-3xl tracking-tighter uppercase"
        >
          <Bitcoin className="w-7 h-7 text-[#F7931A] stroke-[2.5]" />
          Bitbook
        </Link>

        {user && user.paid_entry && (
          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => {
              const Icon = l.icon;
              const active = loc.pathname.startsWith(l.to);
              return (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={l.id}
                  className={`px-2.5 py-2 text-xs font-bold tracking-widest uppercase flex items-center gap-1.5 hover:underline decoration-[#F7931A] decoration-2 underline-offset-4 ${
                    active ? "text-[#F7931A]" : "text-[#0A0A0A]"
                  }`}
                >
                  <Icon className="w-3.5 h-3.5" />
                  {l.label}
                </Link>
              );
            })}
          </nav>
        )}

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Link
                to="/profile"
                data-testid="nav-profile"
                className="flex items-center gap-2 px-3 py-2 text-sm font-bold uppercase tracking-widest border-2 border-black hover:bg-black hover:text-[#FDFBF7] transition-colors"
              >
                <User className="w-4 h-4" />
                {user.name?.split(" ")[0]}
              </Link>
              <button
                data-testid="btn-logout"
                onClick={onLogout}
                className="p-2 border-2 border-black hover:bg-black hover:text-[#FDFBF7] transition-colors"
                aria-label="Logout"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="nav-login"
                className="px-4 py-2 text-sm font-bold uppercase tracking-widest border-2 border-black hover:bg-black hover:text-[#FDFBF7] transition-colors"
              >
                Log In
              </Link>
              <Link
                to="/register"
                data-testid="nav-register"
                className="px-4 py-2 text-sm font-bold uppercase tracking-widest bg-[#F7931A] border-2 border-black btn-brutal"
              >
                Join
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
